import React, { Component } from 'react';

class KioskScrollContainer extends Component {

    render() {
        return(
            <div className="kiosk__column--scroll-container">
                <div className="kiosk__column--scroll">
                	{this.props.children}
                </div>
            </div>
        )
    }
}

export default KioskScrollContainer
